import React from 'react';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { COLORS, device } from '../../../../constants';
import { Box, Title, VerticalBox } from '../../../../components';
import { VertBarElement } from '../VertBarElement';
import { Issues } from '../../../../types/globalTypes';
import { MotionYOffsetBlock } from '../../../../components/Motion';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  issues: Issues[];
}

export const ProjectIssues: React.FC<DivProps> = ({ issues, ...props }) => {
  return (
    <SectionContainer color={COLORS.LIGHT_BG_COLOR}>
      <Box>
        <VerticalBox>
          <SectionTextContainer>
            <Title title="Client's issues" isAnimated={true} />
            <IssueContainer {...props}>
              {issues &&
                issues.map((el, index) => (
                  <VertBarElement key={index} txt={el.Caption} />
                ))}
            </IssueContainer>
          </SectionTextContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};

const IssueContainer = styled(MotionYOffsetBlock)`
  display: grid;
  justify-content: start;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 41px;
  row-gap: 60px;
  @media screen and (${device.xs}) {
    grid-template-columns: 1fr;
  }
  @media screen and (${device.sm}) {
    gap: 30px;
  }
`;
